import React from 'react';

import Alert from '@/components/Alert';
import CancellationText from '@/components/CancellationText';

const FlightsTerms = () => (
  <Alert.Info icon={{ name: 'info', color: 'brand.secondary' }}>
    <CancellationText />
  </Alert.Info>
);

export default FlightsTerms;
